import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  loading: {
    alignItems: 'center',
    backgroundColor: theme.colors.form__background_primary,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    height: 400,
    justifyContent: 'center',
    maxWidth: 'unset',
    padding: theme.spacing(12),
    width: 1280
  },
  spinner: {
    width: 96,
    height: 96
  },
  spinnerText: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.4,
    color: theme.colorPalette.green_100
  }
});

export default makeStyles(styles);
